var _circle, _circle2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 9.5,
    stroke: "#EAEAEA",
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3497_2074",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 26
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 9.5,
    stroke: "#EAEAEA",
    strokeWidth: 7
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3497_2074)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 7.79412V-1L37.5 0.264648L33.5 18.7646L14 34.2646V7.79412Z",
    fill: "#2361FF",
    stroke: "#2361FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.0c9580346255ae900448c850c4c13e1a.svg";
export { ForwardRef as ReactComponent };